/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_GamesInputs */

const th_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีโปรแกรมแข่งขัน`)
};

const en_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fixtures yet.`)
};

const ja_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程はまだありません。`)
};

const zh_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无比赛。`)
};

const es_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay partidos.`)
};

const pt_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo ainda.`)
};

const id_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pertandingan.`)
};

const fr_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match pour l’instant.`)
};

const tl_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang laro.`)
};

const vi_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có trận nào.`)
};

const ko_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 경기가 없습니다.`)
};

const de_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spiele.`)
};

const ru_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчей пока нет.`)
};

const tr_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz maç yok.`)
};

const it_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna partita.`)
};

const pl_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze meczów.`)
};

const uk_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчів поки немає.`)
};

const hi_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई मैच नहीं।`)
};

const ar_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مباريات بعد.`)
};

const ms_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada perlawanan.`)
};

const bn_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও খেলা নেই।`)
};

const zh_tw2_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無比賽。`)
};

const zh_hk2_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無比賽。`)
};

const ur_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی میچ نہیں۔`)
};

const fa_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز بازی‌ای نیست.`)
};

const sw_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna michezo bado.`)
};

const nl_player_no_games = /** @type {(inputs: Player_No_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen wedstrijden.`)
};

/**
* | output |
* | --- |
* | "No fixtures yet." |
*
* @param {Player_No_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_no_games = /** @type {((inputs?: Player_No_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_no_games(inputs)
	if (locale === "ja") return ja_player_no_games(inputs)
	if (locale === "zh") return zh_player_no_games(inputs)
	if (locale === "es") return es_player_no_games(inputs)
	if (locale === "pt") return pt_player_no_games(inputs)
	if (locale === "id") return id_player_no_games(inputs)
	if (locale === "fr") return fr_player_no_games(inputs)
	if (locale === "tl") return tl_player_no_games(inputs)
	if (locale === "vi") return vi_player_no_games(inputs)
	if (locale === "ko") return ko_player_no_games(inputs)
	if (locale === "de") return de_player_no_games(inputs)
	if (locale === "ru") return ru_player_no_games(inputs)
	if (locale === "tr") return tr_player_no_games(inputs)
	if (locale === "it") return it_player_no_games(inputs)
	if (locale === "pl") return pl_player_no_games(inputs)
	if (locale === "uk") return uk_player_no_games(inputs)
	if (locale === "hi") return hi_player_no_games(inputs)
	if (locale === "ar") return ar_player_no_games(inputs)
	if (locale === "ms") return ms_player_no_games(inputs)
	if (locale === "bn") return bn_player_no_games(inputs)
	if (locale === "zh-TW") return zh_tw2_player_no_games(inputs)
	if (locale === "zh-HK") return zh_hk2_player_no_games(inputs)
	if (locale === "ur") return ur_player_no_games(inputs)
	if (locale === "fa") return fa_player_no_games(inputs)
	if (locale === "sw") return sw_player_no_games(inputs)
	if (locale === "nl") return nl_player_no_games(inputs)
	return en_player_no_games(inputs)
});